"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
function default_1(client) {
    return {
        getGroups: function (params) {
            if (params === void 0) { params = {}; }
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, client.get('groups', { params: params })];
                        case 1: return [2 /*return*/, _a.sent()];
                    }
                });
            });
        },
        searchGroups: function (groupName) {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, client.post('groups/search', { group_name: groupName })];
                        case 1: return [2 /*return*/, _a.sent()];
                    }
                });
            });
        },
        getGroup: function (groupId) {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, client.get("groups/" + groupId)];
                        case 1: return [2 /*return*/, _a.sent()];
                    }
                });
            });
        },
        createGroup: function (group) {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, client.post('groups', group)];
                        case 1: return [2 /*return*/, _a.sent()];
                    }
                });
            });
        },
        updateGroup: function (groupId, groupUpdate) {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, client.put("groups/" + groupId, groupUpdate)];
                        case 1: return [2 /*return*/, _a.sent()];
                    }
                });
            });
        },
        removeGroup: function (groupId) {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, client.delete("groups/" + groupId)];
                        case 1: return [2 /*return*/, _a.sent()];
                    }
                });
            });
        },
        addSubscriberToGroup: function (groupId, subscriber) {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, client.post("groups/" + groupId + "/subscribers", subscriber)];
                        case 1: return [2 /*return*/, _a.sent()];
                    }
                });
            });
        },
        addSubscribersToGroup: function (groupId, subscribers, importOptions) {
            if (importOptions === void 0) { importOptions = {}; }
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, client.post("groups/" + groupId + "/subscribers/import", __assign({ subscribers: subscribers }, importOptions))];
                        case 1: return [2 /*return*/, _a.sent()];
                    }
                });
            });
        },
        getSubscribersGroupImport: function (groupId, importId) {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, client.get("groups/" + groupId + "/subscribers/import/" + importId)];
                        case 1: return [2 /*return*/, _a.sent()];
                    }
                });
            });
        },
        getGroupSubscriber: function (groupId, subscriberId) {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, client.get("groups/" + groupId + "/subscribers/" + subscriberId)];
                        case 1: return [2 /*return*/, _a.sent()];
                    }
                });
            });
        },
        getGroupSubscribers: function (groupId, params) {
            if (params === void 0) { params = {}; }
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, client.get("groups/" + groupId + "/subscribers", { params: params })];
                        case 1: return [2 /*return*/, _a.sent()];
                    }
                });
            });
        },
        getGroupSubscriberCount: function (groupId) {
            return __awaiter(this, void 0, void 0, function () {
                var count;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, client.get("groups/" + groupId + "/subscribers/count")];
                        case 1:
                            count = (_a.sent()).count;
                            return [2 /*return*/, count];
                    }
                });
            });
        },
        getGroupSubscribersByType: function (groupId, subscriberType, params) {
            if (params === void 0) { params = {}; }
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, client.get("groups/" + groupId + "/subscribers/" + subscriberType, { params: params })];
                        case 1: return [2 /*return*/, _a.sent()];
                    }
                });
            });
        },
        getGroupSubscribersCountByType: function (groupId, subscriberType) {
            return __awaiter(this, void 0, void 0, function () {
                var count;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, client.get("groups/" + groupId + "/subscribers/" + subscriberType + "/count")];
                        case 1:
                            count = (_a.sent()).count;
                            return [2 /*return*/, count];
                    }
                });
            });
        },
        removeGroupSubscriber: function (groupId, subscriberIdentifier) {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, client.delete("groups/" + groupId + "/subscribers/" + subscriberIdentifier)];
                        case 1: return [2 /*return*/, _a.sent()];
                    }
                });
            });
        },
    };
}
exports.default = default_1;
